import React from 'react';

import { useTimezone } from '@hooks';
import { formatDate, DEFAULT_DATE_FORMAT } from '@utilities/formatDate';

type TimezoneDateProps = {
  children?: string | null;
  format?: string;
  fallback?: React.ReactNode;
  display?: 'inline' | 'date-value';
  className?: string;
};

export const TimezoneDate = (props: TimezoneDateProps) => {
  const {
    children,
    display = 'inline',
    fallback = '',
    format = DEFAULT_DATE_FORMAT,
    className,
  } = props;
  const [timezone] = useTimezone();

  const formattedDate = formatDate(children, timezone, format);

  if (!formattedDate || formattedDate === 'Invalid Date') {
    return <>{fallback}</>;
  }

  if (display === 'date-value') {
    const [date, ...timeParts] = formattedDate.split(' ');
    const time = timeParts.join(' ');

    return (
      <>
        {date} <br /> {time}
      </>
    );
  }

  return <span className={className}>{formattedDate}</span>;
};

export default React.memo(TimezoneDate) as typeof TimezoneDate;
